import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
} from "@mui/icons-material";
import { Button, Grid, Tooltip } from "@mui/material";
import React from "react";

import useCommunicationLog from "./useCommunicationLog";

import { useGetCommunicationLogsQuery } from "app/store/patient/api/patientApi";
import { togglePatientRPMModal } from "app/store/patient/slice/patientSlice";
import CustomTable from "components/common/table/CustomTable";
import { COMMUNICATION_MODES } from "static/constants";
import { formatDateTime } from "utils/date";

const CommunicationLogHistory = (props) => {
  const { role } = props;
  const {
    dispatch,
    bpReadingsList,
    currentRpmRowData,
    fetchRPMPatientData,
    handleToggleDeleteModal,
  } = useCommunicationLog();

  const { data, isLoading, isFetching } = useGetCommunicationLogsQuery(
    {
      patientId: currentRpmRowData?.id,
      fetch: fetchRPMPatientData,
    },
    { refetchOnMountOrArgChange: true }
  );

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        {["admin", "user"].includes(role) && (
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              const bpReadingExist = bpReadingsList?.find(
                (bpReading) => bpReading?.patientId === currentRpmRowData?.id
              );

              dispatch(
                togglePatientRPMModal({
                  type: "communicationLog",
                  value: {
                    open: true,
                    action: "Add",
                    data: bpReadingExist
                      ? bpReadingExist?.communicationLog
                      : {},
                    copyOriginal: !bpReadingExist,
                  },
                })
              );
            }}
          >
            <AddIcon />
            Add Communication Log
          </Button>
        )}
        <div
          style={{
            fontSize: "14px",
            fontWeight: "700",
            margin: "16px 0",
          }}
        >
          Previous Logs
        </div>
        <CustomTable
          columns={[
            {
              header: "Date & Time",
              accessorKey: "communicated_date",
              filterVariant: "text",
              Cell: ({ row }) =>
                row?.original?.communicated_date
                  ? formatDateTime(
                      row?.original?.communicated_date,
                      "MM/DD/YYYY hh:mm A"
                    )
                  : "-",
            },
            {
              header: "Communication Mode",
              accessorKey: "mode",
              filterVariant: "text",
            },
            {
              header: "Duration",
              accessorKey: "duration",
              filterVariant: "text",
              Cell: ({ row }) =>
                row?.original?.duration
                  ? row?.original?.duration + " minutes"
                  : "-",
            },
            {
              header: "By",
              accessorKey: "updated_by",
              filterVariant: "text",
              Cell: ({ row }) => row?.original?.updated_by?.name ?? "-",
            },
            {
              header: "",
              accessorKey: "actions",
              filterVariant: "text",
              hidden: !["admin", "user"].includes(role),
              filtering: false,
              enableSorting: false,
              accessorFn: (rowData) => {
                return (
                  <div style={{ display: "inline-flex" }}>
                    <Tooltip title={"Edit"}>
                      <EditIcon
                        className="editIcon"
                        style={{ marginRight: "10px" }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();

                          const { tableData, ...rest } = rowData;

                          if (
                            rest?.mode !== "" &&
                            !COMMUNICATION_MODES.includes(rest?.mode)
                          ) {
                            rest.mode = "Other";
                            rest.customMode = rowData?.mode;
                          }

                          dispatch(
                            togglePatientRPMModal({
                              type: "communicationLog",
                              value: { open: true, action: "Edit", data: rest },
                            })
                          );
                        }}
                      />
                    </Tooltip>

                    <Tooltip title={"Delete"}>
                      <DeleteIcon
                        className="deleteIcon"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();

                          const { _id } = rowData;
                          handleToggleDeleteModal(true, _id);
                        }}
                      />
                    </Tooltip>
                  </div>
                );
              },
            },
          ]}
          data={data ?? []}
          options={{
            state: {
              isLoading: isLoading || isFetching,
            },
            enableSorting: false,
            tablePageSize: 10,
            headerStyle: { height: "48px" },
            rowStyle: { height: "48px" },
            enablePagination: false,
            enableBottomToolbar: false,
            defaultColumn: {
              size: 150,
            },
          }}
        />
      </Grid>
    </Grid>
  );
};

export default CommunicationLogHistory;
